import { createSelector } from "reselect";
import { IProjectModuleState, IProjectState } from "./reducer";

export function selectProjectState(state: IProjectModuleState): IProjectState {
    return state.projectState;
}
export const selectActiveProject = createSelector(selectProjectState, (state) => state.activeProject);
export const selectProjects = createSelector(selectProjectState, (state) => state.projects);
export const selectSpecialInstances = createSelector(selectProjectState, (state) => state.specialInstances);
